import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/plan',
  component: layout,
  meta: {
    funcID: 'F0003',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'noticeProductionOrder',
      name: `${pre}noticeProductionOrder`,
      meta: {
        ...meta,
        title: () => '生产订单通知书',
        funcID: 'F000301',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/noticeProductionOrder'),
    },
    {
      path: 'noticeProductionOrder/:orderCode/:orderNo?',
      name: `${pre}noticeProductionOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderNo = '' } = $route.params
          return orderNo || '待计划订单'
        },
        funcID: 'F000301',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/plan/noticeProductionOrder/detail'),
    },
    {
      path: 'planOrder',
      name: `${pre}planOrder`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000302',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planOrder'),
    },
    {
      path: 'planOrder/:pageType/:code?',
      name: `${pre}planOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000302',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planOrder/detail'),
    },
    {
      path: 'planFabric',
      name: `${pre}planFabric`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000303',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planFabric'),
    },
    {
      path: 'planFabric/:pageType/:code',
      name: `${pre}planFabric-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000303',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planFabric/detail'),
    },
    {
      path: 'planMaterial',
      name: `${pre}planMaterial`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000304',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planMaterial'),
    },
    {
      path: 'planMaterial/:pageType/:code?',
      name: `${pre}planMaterial-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000304',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planMaterial/detail'),
    },
    {
      path: 'planPackage',
      name: `${pre}planPackage`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000305',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planPackage'),
    },
    {
      path: 'planPackage/:pageType/:code?',
      name: `${pre}planPackage-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000305',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planPackage/detail'),
    },
    {
      path: 'planOrderSchedule',
      name: `${pre}planOrderSchedule`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const types = {}
          return types[$route.params.pageType]
        },
        funcID: 'F000306',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/planOrderSchedule'),
    },
    {
      path: 'noticeInspectionOrder',
      name: `${pre}noticeInspectionOrder`,
      meta: {
        ...meta,
        title: () => '代验货订单通知书',
        funcID: 'F000307',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/noticeInspectionOrder'),
    },
    {
      path: 'noticeInspectionOrder/:orderCode/:orderNo?',
      name: `${pre}noticeInspectionOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderNo = '' } = $route.params
          return orderNo || '代验货订单'
        },
        funcID: 'F000307',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/plan/noticeInspectionOrder/detail'),
    },
    {
      path: 'noticeTcOrder',
      name: `${pre}noticeTcOrder`,
      meta: {
        ...meta,
        title: () => 'TC订单通知书',
        funcID: 'F000308',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/noticeTcOrder'),
    },
    {
      path: 'noticeTcOrder/:orderCode/:orderNo?',
      name: `${pre}noticeTcOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderNo = '' } = $route.params
          return orderNo || 'TC订单'
        },
        funcID: 'F000308',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/noticeTcOrder/detail'),
    },
    {
      path: 'pd/costs/order',
      name: `${pre}pdCostsOrder`,
      meta: {
        ...meta,
        title: () => '订单成本核算',
        funcID: 'F000309',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/pdCostsOrder'),
    },
    {
      path: 'pd/costs/order/:pageType/:pdCostsOrderCode/:orderNo?',
      name: `${pre}pdCostsOrder-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderNo = '' } = $route.query
          return `订单成本核算${orderNo ? ' | ' : ''}${orderNo || ''}`
        },
        funcID: 'F000309',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/pdCostsOrder/detail'),
    },
    {
      path: 'orderFlowSettings',
      name: `${pre}orderFlowSettings`,
      meta: {
        ...meta,
        funcID: 'F000310',
        PID: 'F00',
      },
      component: () => import('@/views/factory/plan/orderFlowSettings'),
    },
  ])('plan-'),
}
